import { Badge } from "@/components/ui/badge";
import { emptyPuzzleStep } from "../empty-puzzle-step";
import {
  ArrayShell,
  BoolField,
  BubbleListEditor,
  RowCard,
  TextField,
  useOpenIndex,
} from "../shared-ui";
import {
  asArray,
  bool,
  isRecord,
  str,
  type PanelProps,
} from "../shared";
import {
  appendAtPath,
  childPath,
  getAtPath,
  setAtPath,
} from "../path-utils";

const PATH = "game.puzzleSteps";

export function PuzzleStepsPanel({ root, disabled, onChangeRoot }: PanelProps) {
  const steps = asArray(getAtPath(root, PATH));
  const { openIndex, setOpenIndex, toggle } = useOpenIndex(steps.length);

  return (
    <div className="flex flex-col gap-3">
      <ArrayShell
        title="谜题"
        count={steps.length}
        disabled={disabled}
        onAdd={() => {
          onChangeRoot(appendAtPath(root, PATH, emptyPuzzleStep()));
          setOpenIndex(steps.length);
        }}
      >
        <ul className="flex flex-col gap-2">
        {steps.map((step, index) => {
          const rec = isRecord(step) ? step : {};
          const question = str(rec.question) || `谜题 ${index + 1}`;
          const free = bool(rec.is_free);
          const itemPath = childPath(PATH, index);
          const patch = (key: string, value: unknown) =>
            onChangeRoot(setAtPath(root, childPath(itemPath, key), value));
          return (
            <RowCard
              key={itemPath}
              title={question}
              open={openIndex === index}
              onToggle={() => toggle(index)}
              disabled={disabled}
              index={index}
              total={steps.length}
              arrayPath={PATH}
              root={root}
              onChangeRoot={onChangeRoot}
            >
              <div className="flex flex-wrap items-center gap-2">
                <Badge variant={free ? "success" : "secondary"}>
                  {free ? "免费" : "付费"}
                </Badge>
                <span className="text-xs text-muted-foreground">
                  第 {index + 1} 关
                </span>
              </div>
              <BoolField
                label="是否为付费关卡"
                value={!free}
                disabled={disabled}
                onChange={(v) => patch("is_free", !v)}
              />
              <TextField
                label="问题"
                value={str(rec.question)}
                disabled={disabled}
                multiline
                onChange={(v) => patch("question", v)}
              />
              <TextField
                label="正确答案（三级 Hint）"
                value={str(rec.correct_answer)}
                disabled={disabled}
                multiline
                onChange={(v) => patch("correct_answer", v)}
              />
              <TextField
                label="一级 Hint：纠正调查方向"
                value={str(isRecord(rec.hints) ? rec.hints.level_1 : "")}
                disabled={disabled}
                multiline
                onChange={(v) =>
                  onChangeRoot(
                    setAtPath(
                      root,
                      childPath(childPath(itemPath, "hints"), "level_1"),
                      v,
                    ),
                  )
                }
              />
              <TextField
                label="二级 Hint：缩小范围并给出解法"
                value={str(isRecord(rec.hints) ? rec.hints.level_2 : "")}
                disabled={disabled}
                multiline
                onChange={(v) =>
                  onChangeRoot(
                    setAtPath(
                      root,
                      childPath(childPath(itemPath, "hints"), "level_2"),
                      v,
                    ),
                  )
                }
              />
              <BubbleListEditor
                root={root}
                path={childPath(itemPath, "error_reply")}
                label="答错回复"
                disabled={disabled}
                onChangeRoot={onChangeRoot}
              />
            </RowCard>
          );
        })}
        </ul>
      </ArrayShell>
    </div>
  );
}
